import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import useUrlSearchParams from '@/hooks/useUrlSearchParams'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getPermissions } from '../../../services'
import { getPermissionColumns } from './columns'
import { Permission } from '../../../types'
import ExpandedPermissionDetail from './expanded-permission-detail'

const PermissionsList = () => {
    const { t } = useTranslation()

    const { queryParams, searchInputProps } = useUrlSearchParams()

    const apiParams = useMemo(
        () => ({
            name: queryParams.q || undefined,
            max: 1000,
        }),
        [queryParams.q]
    )

    const {
        data: permissionsData,
        renderState,
        isFetching,
    } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.AUTHORIZATION_PERMISSIONS, apiParams],
            queryFn: () => getPermissions(apiParams),
            placeholderData: true,
        },
        { showLoading: true, showError: true }
    )

    const rows = permissionsData?.results || []
    const columns = useMemo(() => getPermissionColumns(), [])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Paper>
            <DataTableCustomized<Permission>
                columns={columns}
                rows={rows}
                rowKey={(row) => row.id}
                isFetching={isFetching}
                emptyMessage={t('noData', 'Không có dữ liệu')}
                pagination={{
                    page: 1,
                    pageSize: 20,
                    total: rows.length,
                }}
                toolbar={{
                    search: {
                        ...searchInputProps,
                        placeholder: t('search'),
                    },
                }}
                expandable={{
                    expandedRowRender: (row) => (
                        <ExpandedPermissionDetail row={row} />
                    ),
                    rowExpandable: () => true,
                }}
                bordered
            />
        </Paper>
    )
}

export default PermissionsList
